export default function isJson(string) {
  try {

    if (typeof string !== 'string') return;

    const json = JSON.parse(string);

    if (['number', 'string'].includes(typeof json)) return;

    return json;
  } catch (error) {
    return;
  }
}

